import React from 'react';
import { VideoStatus } from '../../types';

interface StatusBadgeProps {
  status: VideoStatus;
}

// FIX: Moved icon components before their usage in statusStyles to prevent "used before declaration" errors.
const CheckCircleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
  </svg>
);

const ProcessingIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 animate-spin" viewBox="0 0 20 20" fill="currentColor">
        <path d="M10 3a7 7 0 100 14 7 7 0 000-14zM10 15a5 5 0 110-10 5 5 0 010 10z" clipRule="evenodd"/>
        <path d="M10 3a7 7 0 017 7h-2a5 5 0 00-5-5V3z"/>
    </svg>
);

const ErrorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
  </svg>
);

// FIX: Replaced JSX.Element with React.ReactElement to fix 'Cannot find namespace JSX' error.
const statusStyles: Record<VideoStatus, { bg: string; text: string; dot: string, icon: React.ReactElement }> = {
  [VideoStatus.READY]: {
    bg: 'bg-green-500/10',
    text: 'text-green-400',
    dot: 'bg-green-400',
    icon: <CheckCircleIcon />
  },
  [VideoStatus.PROCESSING]: {
    bg: 'bg-yellow-500/10',
    text: 'text-yellow-400',
    dot: 'bg-yellow-400',
    icon: <ProcessingIcon />
  },
  [VideoStatus.ERROR]: {
    bg: 'bg-red-500/10',
    text: 'text-red-400',
    dot: 'bg-red-400',
    icon: <ErrorIcon />
  },
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const styles = statusStyles[status];
  const text = status.charAt(0).toUpperCase() + status.slice(1);

  return (
    <div className={`inline-flex items-center gap-2 px-2.5 py-1 rounded-full text-xs font-medium ${styles.bg} ${styles.text}`}>
      {styles.icon}
      {text}
    </div>
  );
};

export default StatusBadge;